import { ROUTES } from "@/routes_new";
import { Organization } from "@/types/Organization";
import { Badge } from "@components/ui/badge";
import { Button } from "@components/ui/button";
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { FocusIcon, ArrowRightIcon } from "lucide-react";
import { generatePath, Link } from "react-router-dom";

type FallbackProps = {
  orgUuid: Organization["uuid"];
};

export default function Fallback({ orgUuid }: FallbackProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <FocusIcon />
        </EmptyMedia>
        <EmptyTitle className="flex items-center gap-2">
          <Trans>Sök i arkivet</Trans>
          <Badge variant="violet">
            <Trans>Premium</Trans>
          </Badge>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>
            Utforska tidigare ljudbevakning med betalda abonnemang. Skapa en
            bevakning för att övervaka nya omnämnanden.
          </Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent className="flex-row justify-center gap-2">
        <Button asChild>
          <Link
            to={generatePath(ROUTES.MENTION_NEW_ORGID, {
              orgUuid,
            })}
          >
            <Trans>Skapa ny bevakning</Trans>
            <ArrowRightIcon />
          </Link>
        </Button>
      </EmptyContent>
      <Button
        variant="link"
        asChild
        className="text-muted-foreground"
        size="sm"
      >
        <Link
          to={{
            search: "?upsale=true",
          }}
        >
          <Trans>Utforska våra priser</Trans>
        </Link>
      </Button>
    </Empty>
  );
}
